import http from './api'

const route = 'app/comercial/analiseprodutos4/'

export default {
  showAnaliseFaturamento: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showAnaliseFaturamento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },

  showAnaliseProdutoDevolucao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showAnaliseProdutoDevolucao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },

  showAnaliseProdutosKgFaturados: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showAnaliseProdutosKgFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },

  showAnaliseProdutoFatClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showAnaliseProdutoFatClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },

  showGraficoFaturamentoKgGrupo: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showGraficoFaturamentoKgGrupo', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },

  showGraficoFaturamentoPrecoMedioGrupo: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showGraficoFaturamentoPrecoMedioGrupo', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },

  showAnaliseFaturamentoGrupoProdutos: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showAnaliseFaturamentoGrupoProdutos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },

  showFaturamentoGrupoMes: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showFaturamentoGrupoMes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },

  showAnaliseCompartivoFaturamentoMes: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showAnaliseCompartivoFaturamentoMes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },

  showAnaliseProdutoDevolucaoLinha: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showAnaliseProdutoDevolucaoLinha', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      produtos: produtos,
      cidades: cidades,
      linhasProducao: linhasProducao,
    })
  },
}
